// extracted by mini-css-extract-plugin
module.exports = {"volumeButton":"_2jWtiiRL7YCdHGPOubs2ej","button":"_1yztQjuyQG5gXJ8GZRmOLH","volumeControl":"_3eeZ-jry5PDASM3LHpNBQ7"};